<template>
  <div>
    <div class="outer-wrapper">
      <div class="inner-wrapper">
        <div class="left">
          <af-h1 noUnderline>Sidan hittades inte!</af-h1>
          <p>Sidan du letade efter på den här adressen finns inte. Det kan bero på flera saker, till exempel kan adressen vara felstavad eller så har sidan tagits bort.</p>
          <router-link class="beta-information__link" to="/">
            <icon link type="angle-right"></icon>
            <span>Gå till startsidan</span>
          </router-link>
        </div>
        <div class="right">
          <img :src="`${baseURL}static/img/404.svg`" class="img">
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import AfH1 from '@/components/AfH1'
import ExternalLink from '@/components/ExternalLink'
import Icon from '@/components/Icon'

export default {
  components: {
    AfH1,
    ExternalLink,
    Icon
  },
  name: 'PageNotFound',
  data() {
    return {
      baseURL: window.__BASE_URL__
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../variables/custom-media.css';
.outer-wrapper {
  justify-content: center;
  max-width: var(--spacing-max-width-large);
  margin: var(--spacing-large) var(--spacing-half) 0;
  @media (--bp-nis-medium) {
    margin: 0 auto;
  }
  @media (--bp-nis-large) {
    width: var(--spacing-max-width-large);
  }
}

.inner-wrapper {
  display: flex;
  flex-direction: row;
  margin-top: var(--spacing);
  @media (--bp-nis-medium) {
    margin-top: var(--spacing-even-huger);
  }
}

.left {
  margin-bottom: var(--spacing-huge);
  max-width: var(--spacing-max-width-medium);
}

.beta-information__link {
  display: flex;
}

.right {
  padding: -var(--spacing-half);
  display: none;
  @media (--bp-desktop) {
    padding: -var(--spacing-large);
    display: block
  }
}

.img {
  width: 300px;
  margin: 0 var(--spacing-huge);
}

</style>



// WEBPACK FOOTER //
// src/views/404.vue